export default {
  titulo: 'Documentos emitidos',
  campos: ['EstadosEmision', 'MontoTotal', 'Documento', 'TrackId', 'FechaEnvioSii', 'FechaEmision'],
  acccionesIndividuales: ['Bitacora', 'EnviarAprobacion', 'VerReferencias', 'AsociarDocumento', 'DescargarPdf', 'DescargarXml', 'EnviarDte', 'RecuperarCorreoSii', 'ModificarTipoVenta', 'CopiarDocumento', 'AyudaEnDocumento'],
  accionesMasivas: [],
  seleccionMasiva: true,
  categoria: 'emitidos',
  filtrosFijos: {},
  filtrosPorDefecto: {},
  filtrosVariables: {}
};
